import { render, staticRenderFns } from "./HeaderPortfoliosNavigationPopup.vue?vue&type=template&id=5496d89d&"
import script from "./HeaderPortfoliosNavigationPopup.vue?vue&type=script&lang=js&"
export * from "./HeaderPortfoliosNavigationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports